module.exports = __webpack_public_path__ + "img/light_bulb.920f12fb.svg";